/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeCompressedPlacementBlockedItemsDto,
  CompressedPlacementBlockedItemsDto
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type compressedPlacementAdminGetBlockedItemsResponse200 = {
  data: ApiEnvelopeCompressedPlacementBlockedItemsDto
  status: 200
}

export type compressedPlacementAdminGetBlockedItemsResponseSuccess = (compressedPlacementAdminGetBlockedItemsResponse200) & {
  headers: Headers;
};
;

export type compressedPlacementAdminGetBlockedItemsResponse = (compressedPlacementAdminGetBlockedItemsResponseSuccess)

export const getCompressedPlacementAdminGetBlockedItemsUrl = () => {




  return `/api/admin/compressed-placement/blocked-items`
}

export const useCompressedPlacementAdminGetBlockedItemsHook = (): ( options?: RequestInit) => Promise<compressedPlacementAdminGetBlockedItemsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getCompressedPlacementAdminGetBlockedItemsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type compressedPlacementAdminSetBlockedItemsResponse200 = {
  data: ApiEnvelopeCompressedPlacementBlockedItemsDto
  status: 200
}

export type compressedPlacementAdminSetBlockedItemsResponse400 = {
  data: ApiEnvelopeCompressedPlacementBlockedItemsDto
  status: 400
}

export type compressedPlacementAdminSetBlockedItemsResponseSuccess = (compressedPlacementAdminSetBlockedItemsResponse200) & {
  headers: Headers;
};
export type compressedPlacementAdminSetBlockedItemsResponseError = (compressedPlacementAdminSetBlockedItemsResponse400) & {
  headers: Headers;
};

export type compressedPlacementAdminSetBlockedItemsResponse = (compressedPlacementAdminSetBlockedItemsResponseSuccess | compressedPlacementAdminSetBlockedItemsResponseError)

export const getCompressedPlacementAdminSetBlockedItemsUrl = () => {




  return `/api/admin/compressed-placement/blocked-items`
}

export const useCompressedPlacementAdminSetBlockedItemsHook = (): (compressedPlacementBlockedItemsDto?: CompressedPlacementBlockedItemsDto, options?: RequestInit) => Promise<compressedPlacementAdminSetBlockedItemsResponse> => {

      const customFetcher = useSfetchMutator();
      return (compressedPlacementBlockedItemsDto?: CompressedPlacementBlockedItemsDto, options?: RequestInit) => {

        return customFetcher(getCompressedPlacementAdminSetBlockedItemsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(compressedPlacementBlockedItemsDto)
  }
);
      }
  }


